import React from "react";

export default function Notify(ref, type, message)
{
	const options = {
		place: "tc",
		message: (
			<div>
				<div className="text-white">
					{message}
				</div>
			</div>
		),
		type: type,
		icon: "fas fa-exclamation-circle",
		autoDismiss: 5,
	};
	if(ref.current)
		ref.current.notificationAlert(options);
}